import React from 'react';

import { Classes } from '@blueprintjs/core';
import { CourseWrapper } from 'common/entities/courseWrapper/CourseWrapper';
import { FlexRight } from 'common/fragments/Flex';
import Loading from 'common/fragments/Loading';
import NonIdealState from 'common/fragments/NonIdealState';
import { BlockVariant, BlockView } from 'common/views/block/BlockView.view';
import { ButtonVariant, ButtonView } from 'common/views/button/Button.view';
import { CardView } from 'common/views/card/Card.view';
import { CarouselView } from 'common/views/carousel/Carousel.view';
import { DialogView } from 'common/views/dialog/Dialog.view';
import HeadingView, { HeadingVariant } from 'common/views/heading/Heading.view';
import { ImageVariant, ImageView } from 'common/views/image/Image.view';
import { RowsView } from 'common/views/rows/Rows.view';
import { Query } from 'core/api/typedQuery';
import { isEmpty } from 'core/util/ArrayUtils';
import { IPanelProps, Panel } from "../../core/decorators/Panel";
import Entry from './entities/Entry';
import UserTag from './entities/UserTag';
import labelProvider from "./Recommended.labels";
import RecommendedConfig, { ListTypeOptions } from './RecommendedConfig';
import { UserPreferencesPanel } from './userPreferences/UserPreferences.panel';

interface IRecommendedParam {
	language?: string;
	pageSize?: number;
	bundlesEnabled?: boolean;
}
const RecommendedQuery = Query.queryMany<Entry, IRecommendedParam>(Entry);
let UserTagQuery = Query.queryMany<UserTag, any>(UserTag);
const { Labels } = labelProvider;

@Panel({ id: "recommended", configClass: RecommendedConfig, pageParams: true, labelProvider })
export class RecommendedPanel extends React.PureComponent<IPanelProps<RecommendedConfig>> {
    public state = { isOpen: false, reload:false };

    public render() {
        const { config, pageParams } = this.props;
        const { isOpen } = this.state;
        const params={language:this.props.language, pageSize:config.pageSize};
        const paramst={tagSetNames:config.tagSetNames || null};

        if(this.state.reload) {
			UserTagQuery = Query.queryMany<UserTag, any>(UserTag);
        }

        return (
           <div>
            <UserTagQuery key="tagQuery" params={paramst}>
            {
                ({data, loading}) => {

                    if (loading) {
                        return <Loading key="loading" />;
                    }

                    if (isEmpty(data)) {
                        return (
                            <React.Fragment>
                                <Labels.RecommendedNoUserTags />
                                <ButtonView variant={ButtonVariant.SECONDARY} key="edit"
                                    viewKey="EditPreference" onClick={this.showDialog}>
                                        <Labels.RecommendedPreferencesEditLabel />
																		</ButtonView>
														</React.Fragment>
												);
										}

										          const tagsets = data.map(this.tags);

										          return (
												<FlexRight>
														<BlockView viewKey="preference.body">
																{tagsets}
																<ButtonView variant={ButtonVariant.SECONDARY} key="edit"
																viewKey="EditPreference" onClick={this.showDialog}>
																		<Labels.RecommendedPreferencesEditLabel />
																</ButtonView>
														</BlockView>
												</FlexRight>
										);
								}
						}
						</UserTagQuery>

						<RecommendedQuery key="query" params={params}>
								{
										({data, loading}) => {

												if (loading) {
														return <Loading key="loading" />;
												}

												if (isEmpty(data)) {
							return (
								<FlexRight>
									<BlockView viewKey="preference.body">
										<ButtonView variant={ButtonVariant.SECONDARY} key="edit"
											viewKey="EditPreference" onClick={this.showDialog}>
											<Labels.RecommendedPreferencesEditLabel />
										</ButtonView>
									</BlockView>
								</FlexRight>
							);
												}

												const items = data.map(this.renderRecommended);
												return (config.view === ListTypeOptions.CAROUSEL) ?
																		<CarouselView key="carousel" viewKey="carousel" items={items} /> :
				                (config.view === ListTypeOptions.ROWS) ?
																		<RowsView key="rows" viewKey="rows">{items}</RowsView> :
					            items;
										}

								}
						</RecommendedQuery>

						<DialogView key="dialog" isOpen={isOpen} onClose={() => this.setState({isOpen: false})} viewKey="dialog" title="User Preferences"
								onClosed={this.onDialogClosed}>
								<div className={Classes.DIALOG_BODY}>
										<UserPreferencesPanel id="userPreferences" instance=""
												onSaved={this.onPreferencesSaved}
												tagSetNames={config.tagSetNames}>
										</UserPreferencesPanel>
								</div>

						</DialogView>
					</div>
				);
		}

		private tags = (ut:UserTag, index:number) => {
				let separator = "";
				if (index>0) { separator = this.props.config.separator || ", "; }
				return (
						<React.Fragment>
								{separator}
								<span key={index}>{ut.tag.name}</span>
						</React.Fragment>
				);
		}

		private renderRecommended = (entry:Entry) => {

				const w = CourseWrapper.forEntry(entry);

				const content = [
						<ImageView key="thumbnail" style={{width: "100%", height: "150px"}} variant={ImageVariant.THUMBNAIL}
						src={w.getIconUrl()} viewKey="thumbnail" />,

						<BlockView variant={BlockVariant.CARD_CONTENT} viewKey="course-title" key="course-title">
								<HeadingView children={w.getTitle()}  viewKey="course-title" />
						</BlockView>,

						<BlockView variant={BlockVariant.CARD_CONTENT} viewKey="course-subtitle" key="card-subtitle">
								<HeadingView viewKey="course-subtitle" >
                        <div dangerouslySetInnerHTML={{__html: w.getDescription().length > 200 ? w.getDescription().substr(0, 200) + "..." : w.getDescription() }} />
								</HeadingView>
						</BlockView>,

						<ButtonView key="launchLink" variant={ButtonVariant.PRIMARY} viewKey="launch.link" onClick={() => w.launchCourse()}>
								<Labels.Launch />
						</ButtonView>
				];

				return (
						<CardView key={w.getItemId()} viewKey="card">
								{content}
						</CardView>
				);
		}

		private showDialog = () => {
				this.setState({isOpen: true});
		}

		private closeDialog = () => {
				this.setState({isOpen: false});
		}
		private onDialogClosed = () => {

		}

		private onPreferencesSaved = (entity) => {
				this.closeDialog();
				this.setState({reload: true});
		}
}



// WEBPACK FOOTER //
// ./src/panels/recommended/Recommended.panel.tsx